import { Prescription, License } from '../../types/data';
import Status from '../status/status';
import { getCountDocument } from '../../utils/utils';

type PanelStatusProps = {
  data: Prescription[] | License[];
  isLicenses?: boolean;
  filters?: {
    statusPrescription?: string[];
    statusLicanse?: string[];
    status?: string[];
    actualClosingDateRange?: {
      startDate?: string;
      endDate?: string;
    };
  };
};

function PanelStatus({ data, isLicenses, filters }: PanelStatusProps) {
  let filteredData = [...data];
  //! по статусу предписания
  if (filters?.statusPrescription && filters?.statusPrescription?.length > 0) {
    filteredData = filteredData.filter((item) => filters.statusPrescription?.includes(item.status.name));
  }
  //! по статусу лицензии
  if (filters?.statusLicanse && filters?.statusLicanse?.length > 0) {
    filteredData = filteredData.filter((item) => filters.statusLicanse?.includes(item.status.name));
  }

  //! по статусу действий (предписания и лицензии)
  if (filters?.status && filters?.status?.length > 0) {
    filteredData = filteredData.filter((item: any) => filters?.status?.includes(item.actionStatus));
  }

  if (filters?.actualClosingDateRange?.startDate && filters?.actualClosingDateRange?.endDate) {
    filteredData = filteredData.filter((item: any) => {
      if (!item.actualClosingDatePrescription?.startDate) return false;

      const itemDate = new Date(item.actualClosingDatePrescription.startDate);
      const startDate = new Date(filters.actualClosingDateRange?.startDate!);
      const endDate = new Date(filters.actualClosingDateRange?.endDate!);

      return itemDate >= startDate && itemDate <= endDate;
    });
  }

  return (
    <div className='flex justify-center items-center gap-5 p-4 bg-white mb-5 rounded-lg'>
      <Status type='В процессе' isCount count={isLicenses ? getCountDocument(filteredData as License[], 'В процессе') : getCountDocument(filteredData as Prescription[], 'В процессе')} />
      {isLicenses ? (
        <Status type='Просрочен' isCount count={getCountDocument(filteredData as License[], 'Просрочен')} />
      ) : (
        <Status type='Просрочено' isCount count={getCountDocument(filteredData as Prescription[], 'Просрочено')} />
      )}
      {isLicenses ? (
        <Status type='Действующий' isCount count={getCountDocument(filteredData as License[], 'Действующий')} />
      ) : (
        <Status type='Выполнено' isCount count={getCountDocument(filteredData as Prescription[], 'Выполнено')} />
      )}
      {isLicenses && <Status type='В архиве' isCount count={getCountDocument(filteredData as License[], 'В архиве')} />}
    </div>
  );
}

export default PanelStatus;
